export const PAN_FUNDS = 'PAN_FUNDS';
export const PAN_FUNDS_SUCCESS = 'PAN_FUNDS_SUCCESS';
export const PRE_LOGIN_TRANSMISSION = 'PRELOGIN_TRANSMISSION';
export const PRE_LOGIN_TRANSMISSION_SUCCESS = 'PRELOGIN_TRANSMISSION_SUCCESS';

export const GET_DEPOID_SUCCESS = 'GET_DEPOID_SUCCESS';
export const GET_DEPOID = 'GET_DEPOID';

export const SUBMIT_DEPOID_SUCCESS = 'SUBMIT_DEPOID_SUCCESS';
export const SUBMIT_DEPOID = 'SUBMIT_DEPOID';

export const DORMANT_PAN_CHECK_SUCCESS = 'DORMANT_PAN_CHECK_SUCCESS';
export const DORMANT_PAN_CHECK = 'DORMANT_PAN_CHECK';

export const REGISTER_DORMANT = 'REGISTER_DORMANT';
export const REGISTER_DORMANT_SUCCESS = 'REGISTER_DORMANT_SUCCESS';

export const VERIFY_DORMANT= 'VERIFY_DORMANT';
export const VERIFY_DORMANT_SUCCESS = 'VERIFY_DORMANT_SUCCESS';

export const GET_INACTIVE_FOLIOS = 'GET_INACTIVE_FOLIOS';
export const GET_INACTIVE_FOLIOS_SUCCESS = 'GET_INACTIVE_FOLIOS_SUCCESS';

export const SEARCH_INACTIVE_FOLIOS = 'SEARCH_INACTIVE_FOLIOS';
export const SEARCH_INACTIVE_FOLIOS_SUCCESS = 'SEARCH_INACTIVE_FOLIOS_SUCCESS';

export const GET_ATTEMPTS_LEFT = 'GET_ATTEMPTS_LEFT';
export const GET_ATTEMPTS_LEFT_SUCCESS = 'GET_ATTEMPTS_LEFT_SUCCESS';

export const GET_AMFI_CAS = 'GET_AMFI_CAS';
export const GET_AMFI_CAS_SUCCESS = 'GET_AMFI_CAS_SUCCESS';

export const AMFI_CAS_API = '/amfi/generateAmfiCas';